export const getBasename: () => string = () => window.location.pathname.replace(/^\/([^/]+).*/, '/$1');
